import { LowestPrices } from "@/templates/types";

export type PricingPlanKey = keyof LowestPrices;

export interface PricingBlockProps {
  t: (key: string) => string;
  lowestPrices: LowestPrices;
}

export const toDataQaSlug = (value: string): string =>
  value.toLowerCase().trim().replace(/\s+/g, "-");
